
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { UserManager, UserManagerSettings, User, WebStorageStateStore, } from 'oidc-client';

import { AUTH } from '../layout/core/app-config';
import { CommunicationService } from '../layout/shared/communication.service';

@Injectable()
export class AuthService {
  private manager = new UserManager(getClientSettings());
  private user: User = null;

  constructor(private httpClient: HttpClient, private communicationService: CommunicationService) {
    this.manager.clearStaleState().catch(e => console.log('zslinfo:' + e));
    this.manager.getUser().then(user => {
      this.user = user;
    });

    this.manager.events.addUserLoaded(user => {
      console.log('user loaded');
      this.manager.clearStaleState().catch(e => console.log('zslinfo:' + e));
      this.user = user;
      //for profile data sync
      if (!this.getItem('LoginId') || (+this.getItem('LoginId') != +user.profile.sub))
        this.profileDataService(AUTH.USERINFO || '', user.access_token)
          .subscribe(s => {
            this.setDataFromProfile(s);
            communicationService.profileReceived(true);
          });
    });
    this.manager.events.addUserUnloaded(() => {
      console.log('user unloaded');
      this.user = null;
    });
    this.manager.events.addUserSignedOut(() => {
      console.log('user signed out:' + this.user);
      localStorage.clear();
      this.signOut();
    });
    this.manager.events.addSilentRenewError(err => {
      console.log('silent event:' + err);
    });

  }

  isLoggedIn(): boolean {
    return this.user != null && !this.user.expired;
  }

  getClaims(): any {
    return this.user.profile;
  }

  getAuthorizationHeaderValue(): string {
    return `${this.user.token_type} ${this.user.access_token}`;
  }

  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }

  completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(user => {
      // this.setDataFromToken(user.access_token);
    })
  .catch(e => console.log('completeAuthentication-error:' + e));
  }

  signOut(isUnAuthorized:boolean=false) {
    this.manager.getUser().then(user => {
    
      localStorage.clear();
      if (user && user.id_token)
      {
        this.manager.signoutRedirect({ id_token_hint: user.id_token });
      }
      else if (!isUnAuthorized)
        this.startAuthentication();
      this.manager.clearStaleState().catch(e => console.log('zslinfo:' + e));
    }).catch(c => console.error(c));
  }

  //Custom code assign claims
  setDataFromProfile(data) {
    //var data = this.getDataFromToken(token);
    //wes
    if (data['role'] != null && data['role'] != undefined)
      for (var i = 0; i < data['role'].length; i++) {
        if (data['role'][i] === "dataEventRecords.admin") {
          // this.HasAdminRole = true;
        }
      }

    if (data['sub'] != null && data['sub'] != undefined)
      this.setItem('LoginId', data['sub']);
    if (data['CompanyId'] != null && data['CompanyId'] != undefined)
      this.setItem('CompanyId', data['CompanyId']);
    if (data['name'] != null && data['name'] != undefined)
      this.setItem('Email', data['name']);
    if (data['DisplayName'] != null && data['DisplayName'] != undefined)
      this.setItem('DisplayName', data['DisplayName']);
    if (data['CompanyCode'] != null && data['CompanyCode'] != undefined)
      this.setItem('CompanyCode', data['CompanyCode']);
    if (data['Culture'] != null && data['Culture'] != undefined)
      this.setItem('Culture', data['Culture']);
    if (data['LanguageId'])
      this.setItem('LanguageId', data['LanguageId']);
    if (data['Language'])
      this.setItem('Language', data['Language']);
    // //CURRENCYPIPE
    //     var cp = new CurrencyPipe('Currency');
    // var Currencyformat = cp.transform(0, data['Currency'], true);
    // var CurrencySymbol = Currencyformat.replace('0.00', '');
    if (data['Currency'] != null && data['Currency'] != undefined)
      this.setItem('Currency', data['Currency']);
    //THIS CODE ADDED BY BALAMURUGAN 26/12/2017
    if (data['CountryId'] != null && data['CountryId'] != undefined)
      this.setItem('CountryId', data['CountryId']);
    if (data['MaxRoleGroup'] != null && data['MaxRoleGroup'] != undefined)
      this.setItem('MaxRoleGroup', data['MaxRoleGroup']);
    if (data['VendorId'] != null && data['VendorId'] != undefined)
      this.setItem('VendorId', data['VendorId']);
    if (data['role'] != null && data['role'] != undefined)
      this.setItem('Roles', JSON.stringify(data['role']));
    if (data['ThemeId'] != null && data['ThemeId'] != undefined)
      this.setItem('ThemeId', data['ThemeId']);
    if (data['TimeZoneId'] != null && data['TimeZoneId'] != undefined)
      this.setItem('TimeZoneId', data['TimeZoneId']);
    if (data['IsManager'] != null && data['IsManager'] != undefined)
      this.setItem('IsManager', data['IsManager']);
    if (data['HomePageId'] != null && data['HomePageId'] != undefined)
      this.setItem('HomePageId', data['HomePageId']);
    if (data['BusinessAddressId'] != null && data['BusinessAddressId'] != undefined)
      this.setItem('BusinessAddressId', data['BusinessAddressId']);
    if (data['Mpin'] != null && data['Mpin'] != undefined)
      this.setItem('Mpin', data['Mpin']);
    if (data['ManagerId'] != null && data['ManagerId'] != undefined)
      this.setItem('ManagerId', data['ManagerId']);
    if (data['IsTech'] != null && data['IsTech'] != undefined)
      this.setItem('IsTech', data['IsTech']);

    if (data['LogoPath'] != null && data['LogoPath'] != undefined)
      this.setItem('LogoPath', data['LogoPath']);
    if (data['MapId'] != null && data['MapId'] != undefined)
      this.setItem('MapId', data['MapId']);
    if (data['MapKey'] != null && data['MapKey'] != undefined)
      this.setItem('MapKey', data['MapKey']);
    if (data['IsLatLonBased'] != null && data['IsLatLonBased'] != undefined)
      this.setItem('IsLatLonBased', data['IsLatLonBased']);
    if (data['IsProjectEnabled'] != null && data['IsProjectEnabled'] != undefined)
      this.setItem('IsProjectEnabled', data['IsProjectEnabled']);
    if (data['DefaultCountryId'] != null && data['DefaultCountryId'] != undefined)
      this.setItem('DefaultCountryId', data['DefaultCountryId']);
    if (data['ReturnURL'])
      this.setItem('ReturnURL', data['ReturnURL']);
    if (data['PasswordExpired'] != null && data['PasswordExpired'] != undefined)
      this.setItem('PasswordExpired', data['PasswordExpired']);
    if (data['LicenseExpired'] != null && data['LicenseExpired'] != undefined)
      this.setItem('LicenseExpired', data['LicenseExpired']);
    // Added by Yogesh M on 03/09/2020 for Accessible Region & Worktypes Start
    if (data['HasAccessToAllRegions'] != null && data['HasAccessToAllRegions'] != undefined)
      this.setItem('HasAccessToAllRegions', data['HasAccessToAllRegions']);
    if (data['HasAccessToAllWorkTypes'] != null && data['HasAccessToAllWorkTypes'] != undefined)
      this.setItem('HasAccessToAllWorkTypes', data['HasAccessToAllWorkTypes']);
    // Added by Yogesh M on 03/09/2020 for Accessible Region & Worktypes End
  }
  urlBase64Decode(str) {
    let output = str.replace('-', '+').replace('_', '/');
    switch (output.length % 4) {
      case 0:
        break;
      case 2:
        output += '==';
        break;
      case 3:
        output += '=';
        break;
      default:
        throw 'Illegal base64url string!';
    }
    return window.atob(output);
  }
  getDataFromToken(token) {
    var data = {};
    if (typeof token !== 'undefined') {
      var encoded = token.split('.')[1];
      data = JSON.parse(this.urlBase64Decode(encoded));
    }
    return data;
  }
  public getItem(key: string) {
    return localStorage.getItem(key);
  }
  private setItem(key: string, value: any) {
    return localStorage.setItem(key, value);
  }
  profileDataService(url: string, token: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + decodeURIComponent(token));

    return this.httpClient.get<Observable<any>>(url, {
      headers: headers,
    });
  }
  //

} //AuthService ends

export function getClientSettings(): UserManagerSettings {
  var code = window.location.pathname.split('/')[1];
  return {
    userStore: new WebStorageStateStore({ store: localStorage }),
    authority: AUTH.AUTHORITY,//'http://localhost:5000/',
    client_id: 'angular2client', //fp_web_client angular2client
    redirect_uri: AUTH.REDIRECT + 'auth-callback', //'http://localhost:4200/auth-callback',
    post_logout_redirect_uri: AUTH.REDIRECT, // 'http://localhost:4200/',
    response_type: "id_token token", //code
    scope: "dataEventRecords openid",
    filterProtocolClaims: true,
    loadUserInfo: false,
    automaticSilentRenew: true,
    monitorSession: true,
    silent_redirect_uri: AUTH.REDIRECT + 'silent-refresh.html', //'http://localhost:4200/silent-refresh.html'
    extraQueryParams: { code: code }
  };
}






